import { app_configs } from "../configs";

const { serverUrl } = app_configs;

const  origin  = `${serverUrl}/account`

/** login */
export const authenticateUser = (email, password) => {
    return fetch(`${origin}/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({ email, password })
    })
}


/** logout */
export const deauthenticateUser = (token) => {
    return fetch (`${serverUrl}/logout`,{
        method: "PATCH",
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })   
}


/** register user */
export const registerUser = (userData) => {
    return fetch(`${origin}/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        mode: "cors",
        body: JSON.stringify(userData)
    })
}

/** authorize account */
export const authorizeUser = (token) => {
    return fetch(`${origin}/myaccount`, {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })
}


/** update account */
export const updateUser = (userData, token) => {
    return fetch(`${origin}/update`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
        mode: "cors",
        body: JSON.stringify(userData)
    })
}


/** delete account */
export const deleteAccount = (token) => {
    return fetch(`${origin}/delete`, {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })
}